import { Reveal } from "@/components/Reveal";
import { ScrambleText } from "@/components/ScrambleText";

const STATS = [
  { value: "+1,300%", label: "Growth in deepfake fraud" },
  { value: "1 in 127", label: "Calls now fraudulent" },
  { value: "68%", label: "Of enterprises already hit" },
];

export default function Problem() {
  return (
    <section id="threat" data-testid="threat-section" className="px-6 py-28 sm:px-10 lg:px-20 lg:py-40">
      <div className="mx-auto grid max-w-6xl items-start gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="border border-white/5 bg-[#1C1F2E] p-10 lg:p-14">
            <p data-testid="threat-eyebrow" className="text-xs uppercase tracking-[0.35em] text-[#C4A24C]">
              <ScrambleText text="01 / The Threat" />
            </p>
            <h2 className="mt-8 font-serif text-4xl text-[#C4A24C] sm:text-5xl">
              $25 Million. One Zoom Call.
            </h2>
            <p className="mt-8 text-sm leading-relaxed text-[#E4E5EA]/90 sm:text-base">
              In 2024, a finance employee at engineering firm Arup joined a video call with what
              appeared to be the company's CFO and senior colleagues. Every participant was a
              deepfake — and $25 million was transferred to the attackers.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div data-testid="threat-stats" className="flex flex-col gap-12 border-l border-[#C4A24C]/70 pl-8 lg:pl-12 lg:pt-2">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`threat-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <div className="font-serif text-5xl text-[#E05D4A] lg:text-6xl">{s.value}</div>
                <div className="mt-3 text-sm tracking-wide text-[#6B7280]">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
